import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { FirmaService } from 'src/app/_services/firma.service';

@Component({
  selector: 'app-firma-mustahzar',
  templateUrl: './firma-mustahzar.component.html',
  styleUrls: ['./firma-mustahzar.component.css']
})
export class FirmaMustahzarComponent implements OnInit {
  @BlockUI('changelog') blockUIChangelog: NgBlockUI;

  public breadcrumb: any;
  options = {
    close: true,
    expand: true,
    minimize: true,
    reload: true
  };
  constructor(private firmaService:FirmaService,private activeRoute:ActivatedRoute) { }
  id:any;
  mustahzarlar:any[];
  ngOnInit() {

       this.id = this.activeRoute.snapshot.paramMap.get('id')!;

    this.getMustahzarlar();
  }
  
  getMustahzarlar(){
    console.log(this.id);
    this.firmaService.firmamustahzar(this.id).subscribe(res=>{
        this.mustahzarlar=res;
    })
  }

  reloadChangelog() {
    this.blockUIChangelog.start('Loading..');

    setTimeout(() => {
      this.blockUIChangelog.stop();
    }, 2500);
  }
}
